import { DrillScoring } from '@core';

export const drillScoringLabelMapper = (scoring: DrillScoring): string => {
  switch (scoring) {
    case DrillScoring.RepsOnly:
      return 'Reps only';
    case DrillScoring.TimePerRep:
      return 'Time per rep';
    case DrillScoring.HitFactor:
      return 'Hit factor';
  }
};
